import { render, staticRenderFns } from "./SimplifiedEditing.vue?vue&type=template&id=739fc53b&lang=pug"
import script from "./SimplifiedEditing.vue?vue&type=script&lang=js"
export * from "./SimplifiedEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports